import type { SnackbarOrigin } from '@mui/material';
import type { ToasterMessageProp } from 'setup/types/core';
import type { ToasterOptions } from './types';

export const DEFAULT_TOASTER_POSITION: SnackbarOrigin = {
  vertical: 'bottom',
  horizontal: 'center',
};

export const DEFAULT_TOASTER_HIDE_DELAY = 3000;

export function normalizeToasterMessage(
  message: ToasterOptions['message']
): ToasterMessageProp {
  if (typeof message === 'string') {
    return { id: message };
  }
  return message as ToasterMessageProp;
}
